import {
  AvailabilitySeatingAreaTag,
  SlotSeatingArea,
} from '@models/Availability'
import {
  Alert,
  Button,
  Card,
  Flex,
  Space,
  Tag,
  Tooltip,
  Typography,
} from 'antd'
import { FC, useRef, useState } from 'react'

const { Text } = Typography

const AvailabilityViewerSeatingArea: FC<{
  area: SlotSeatingArea
}> = ({ area }) => {
  const RenderTag: FC<{ tag: AvailabilitySeatingAreaTag }> = ({ tag }) => (
    <Tooltip
      title={
        <Card>
          <Space orientation="vertical">
            <Text>
              Category: <Text copyable>{tag.category}</Text>
            </Text>
            <Text>
              Name: <Text copyable>{tag.name}</Text>
            </Text>
          </Space>
        </Card>
      }
    >
      <Tag>{tag.name}</Tag>
    </Tooltip>
  )

  const TagsSection: FC<{
    title: string
    tags?: AvailabilitySeatingAreaTag[]
  }> = ({ title, tags = [] }) => (
    <Space orientation="horizontal">
      <Text>{title}</Text>
      {(tags ?? []).map((tag, index) => (
        <RenderTag key={index} tag={tag} />
      ))}
    </Space>
  )

  const canBook = useRef(!!area.slotId).current
  const [showDescription, setShowDescription] = useState(false)

  return (
    <>
      {!canBook && (
        <Flex align="center" justify="center">
          <Tag key={area.id} color="red">
            Unavailable
          </Tag>
        </Flex>
      )}
      {canBook && (
        <Flex vertical>
          <TagsSection title="PMS tags:" tags={area.accessRuleTags} />
          <TagsSection
            title="Tags added by Pléthore:"
            tags={area.loyaltyTierTags}
          />
          {area.longDescription && (
            <>
              <Button
                type="link"
                size="small"
                title="Toggle long description"
                onClick={() => setShowDescription(!showDescription)}
              >
                {showDescription ? 'Hide' : 'Show'} long description
              </Button>
              {showDescription && (
                <Alert
                  title={
                    <div
                      dangerouslySetInnerHTML={{ __html: area.longDescription }}
                    />
                  }
                  type="info"
                  showIcon
                />
              )}
            </>
          )}
        </Flex>
      )}
    </>
  )
}

type AvailabilityViewerSeatingAreaType = {
  SeatingArea: typeof AvailabilityViewerSeatingArea
}

export { AvailabilityViewerSeatingArea, type AvailabilityViewerSeatingAreaType }
